<template>
  <RouterLink
    :to="{
      name: 'accounts.projects.project',
      params: {
        accountId: notification.data.account_id,
        projectId: notification.data.project_id,
      },
    }"
    v-slot="{ href, navigate }"
  >
    <a :href="href" class="block space-y-1" @click="navigate">
      <div v-html="message" class="text-gray-800" />
      <span class="text-xs inline-block text-gray-600">
        {{ createdAt }}
      </span>
    </a>
  </RouterLink>
</template>

<script>
import moment from 'moment';
import { marked } from 'marked';

export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  computed: {
    message() {
      return marked(this.notification?.data?.message || '');
    },
    createdAt() {
      return moment(this.notification.createdAt).fromNow();
    },
  },
};
</script>
